import { Form } from "react-bootstrap";

function PackageSelect({ value, onChange, ...props }) {
  return (
    <Form.Select
      value={value}
      onChange={e => onChange(parseInt(e.target.value))}
      {...props}
    >
      <option value="0">...</option>
      <option value="1">کارتن</option>
      <option value="2">کیسه</option>
      <option value="6">پاکت</option>
      <option value="8">پاکت فلایر</option>
      <option value="7">پاکت جوف</option>
      <option value="3">پاکت حباب دار</option>
      <option value="4">حباب پیچ</option>
      <option value="5">فوم پیچ</option>
    </Form.Select>
  );
}
export default PackageSelect;
